import {useCallback, useEffect, useState} from 'react';

export const useFetchStatus = (initialLoading = false) => {
  const [loading, setLoading] = useState(initialLoading);
  const [error, setError] = useState(false);

  useEffect(() => {
    return () => {
      setError(false);
      setLoading(false);
    };
  }, []);

  return {
    isLoading: loading,
    isFailed: error,
    setLoadingStatus: setLoading,
    setFailStatus: useCallback(() => setError(true), []),
    clearFailStatus: useCallback(() => setError(false), []),
  };
};
